export default "__VITE_ASSET__idKtlZgb__"